import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/OrderBankDarah";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "order-bank-darah"
})
class OrderBankDarahStore extends VuexModule {
  count = 0;

  @Mutation
  SET_COUNT(val: number) {
    this.count = val || 0;
  }

  get badgeText(): string {
    if (!this.count) return "";
    return this.count > 99 ? "99+" : String(this.count);
  }

  @Action({ rawError: true })
  async fetchCount(): Promise<void> {
    const jumlah = await Service.count().catch(() => 0);
    this.SET_COUNT(jumlah);
  }
}

export default getModule(OrderBankDarahStore);
